import { render, staticRenderFns } from "./ProfileTransfer.vue?vue&type=template&id=bd7409e2&scoped=true"
import script from "./ProfileTransfer.vue?vue&type=script&lang=js"
export * from "./ProfileTransfer.vue?vue&type=script&lang=js"
import style0 from "./ProfileTransfer.vue?vue&type=style&index=0&id=bd7409e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7409e2",
  null
  
)

export default component.exports